const Spinner = () => {
  return (<div className="spinner-container">
    <img
        src="/logo192.png" // ⬅ Replace this with your spinner logo path
        alt="Loading..."
        className="spinner"
    />
  </div>)
}

export default Spinner